import React from "react";

export const Register = () => {
  return (
    <div className="flex column">
      <h1>Register</h1>
    </div>
  )
}
